interface SEOSchemaProps {
  type: 'Organization' | 'WebSite' | 'WebPage' | 'Article' | 'FAQPage';
  data?: Record<string, unknown>;
}

export default function SEOSchema({ type, data = {} }: SEOSchemaProps) {
  const baseOrg = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '虚空韩漫网',
    url: 'http://0661yes.cn/',
    description: '虚空韩漫网支持韩漫在线阅读，拥有免费的韩国漫画大全和无删减下拉式韩漫',
    email: 'hello@0661yes.cn',
    telephone: '400-888-6666',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '望京SOHO T1 1208室',
      addressLocality: '北京',
      addressRegion: '朝阳区',
      addressCountry: 'CN',
    },
    sameAs: [
      'http://0661yes.cn/',
      'http://0661yes.cn/xukongmanhua',
    ],
  };

  const baseWebSite = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '虚空韩漫网',
    url: 'http://0661yes.cn/',
    description: '虚空韩漫网支持韩漫在线阅读，拥有免费的韩国漫画大全和无删减下拉式韩漫',
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: 'http://0661yes.cn/search?q={search_term_string}',
      },
      'query-input': 'required name=search_term_string',
    },
  };

  const schemas: Record<string, Record<string, unknown>> = {
    Organization: baseOrg,
    WebSite: baseWebSite,
    WebPage: {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: data.name || '虚空韩漫网',
      description: data.description || '虚空韩漫网支持韩漫在线阅读，拥有免费的韩国漫画大全和无删减下拉式韩漫',
      url: data.url || 'http://0661yes.cn/',
      isPartOf: {
        '@type': 'WebSite',
        name: '虚空韩漫网',
        url: 'http://0661yes.cn/',
      },
    },
    Article: {
      '@context': 'https://schema.org',
      '@type': 'Article',
      headline: data.headline || '',
      description: data.description || '',
      author: {
        '@type': 'Person',
        name: data.author || '',
      },
      datePublished: data.datePublished || '',
      dateModified: data.dateModified || '',
      image: data.image || '',
      publisher: {
        '@type': 'Organization',
        name: '虚空韩漫网',
      },
    },
    FAQPage: {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: (data.questions as Array<{ question: string; answer: string }>)?.map((q) => ({
        '@type': 'Question',
        name: q.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: q.answer,
        },
      })) || [],
    },
  };

  const schema = schemas[type] || {};

  return <script type="application/ld+json">{JSON.stringify(schema)}</script>;
}